// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/global.css'
// 导入字体图标
import './assets/fonts/iconfont.css'
import axios from 'axios'

// import 'lib-flexible/flexible.js'

Vue.config.productionTip = false
// axios.defaults.baseURL='https://balimiao.cn/bbadmin_back/index'
// axios.defaults.baseURL='/api'
axios.defaults.baseURL=process.env.VUE_APP_URL
console.log(process.env.VUE_APP_URL)
axios.interceptors.request.use(config => {
    console.log(config)
    // 为请求头对象，添加token验证的Authorization字段
    config.headers.Authorization = window.sessionStorage.getItem('token')
    // 在最后必须 return config
    return config
})
Vue.prototype.$http = axios

Vue.filter('dataFormat', function (originVal) {
    const dt = new Date(originVal*1000)

    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')

    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')
    // yyyy-mm-dd hh:mm:ss
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})


const baseSize = 15
function setRootFontSize() {
    // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
    const scale = document.documentElement.clientWidth / 1920
    // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
    document.documentElement.style.fontSize = (baseSize*scale)>22?22:(baseSize*scale)+ 'px'
}
setRootFontSize();
// window.addEventListener("resize", setRootFontSize, false);
window.onresize=setRootFontSize;
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
